import { Component, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PaginationInstance } from 'ngx-pagination';
import { GlobalService } from 'src/app/services/global/global.service';
import { AddCategoryComponent } from '../../company-settings/add-category/add-category.component';
import { MatDialog } from '@angular/material/dialog';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { CommonService } from 'src/app/services/common/common.service';
import { AppService } from 'src/app/services/app/app.service';
import { ConfirmationModalComponent } from '../../dialog-modal/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-payroll',
  templateUrl: './payroll.component.html',
  styleUrls: ['./payroll.component.scss']
})
export class PayrollComponent {
  public displayedColumns: string[] = ['category', 'sub_category', 'action'];
  public dataSource = new MatTableDataSource([
    // {j_c:"Kitchen Porter",sub_c:[
    //   {j_sc:"Relief Chef",r:23},
    //   {j_sc:"Relief Chef",r:23},
    //   {j_sc:"Relief Chef",r:23}
    // ]},
    // {j_c:"Ass",sub_c:[{j_sc:"Kitchen",r:4}]},
  ]);
  public count!: any;
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public searchInput!: string;
  @Input() employeeId!: string | number;
  constructor(private dialog: MatDialog, private recruiterService: RecruiterService, private commonService: CommonService, private appService: AppService) { }

  ngOnInit(): void {

    this.onPageChange(1)
    // this.getList()
  }
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    this.getList()
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
    this.getList()
  }
  onSearch(event: any) { }
  onAddEdit(type, item) {
    // same menu opens from different places one is from view employee page/ main company setting page while adding new company
    let objData = {
      isEmployeeSetting: true,
      wages_type: "spe_emp",
      em_i: this.employeeId,
    }
    if (type == 'edit') {
      objData["category_data"] = item
    }
    const dialogRef = this.dialog.open(AddCategoryComponent, {
      data: objData,
      width: '70%', minWidth: '300px', maxWidth: '750px', height: '98%',
      maxHeight: '680px',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      // minHeight:'200px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["data_added"] == true) {
          this.getList()
        }
      }
    });
  }
  onDeleteItem(id: any) {
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: {
        api_type: "delete_content",
        content_type: "delete_company_category",
        id: id, wages_type: "spe_emp",
        em_i: this.employeeId
      }
    }));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        this.getList()
      }
    });
  }
  getList() {
    //spe_emp here means specific employee hence pass the employee id also.
    let objReq = {
      "w_t": "spe_emp",
      "jc_id": "",
      "em_i": this.employeeId,
      "co_i": "",
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
    }
    this.dataSource = new MatTableDataSource([])
    this.recruiterService.getJobCategories(objReq).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          this.dataSource = new MatTableDataSource(success.msg);
         
          this.count = success.count;
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      }
    })
  }
  onSaveWages(item) {
    if (item.wages == "" || item.wages == null || item.wages == undefined) {
      return item["error"] = "This is required";
    }
    else if (item.wages < 0) {
      return item["error"] = "Please add non-negative value";
    }
    else {
      item["error"] = "";
      const dialogRef = this.dialog.open(ConfirmationModalComponent, {
        data: { content_type: 'wages' }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result["confirm_yes"] == true) {
            let objReq = {
              "j_sc_id": item.id,
              "w_t": "spe_emp",
              "wages": item.wages,
              "em_i": this.employeeId
            }
            this.recruiterService.saveWages(objReq).subscribe({
              next: (success: any) => {
                // this.spinner.hide();
                if (success.status == 200) {
                  this.appService.showToastMessage('success', success.msg)
                }
              },
              error: (error: any) => {
                this.commonService.handleError(error)
              }
            })
          }
        }
      });
    }
    return;
  }
}